export default __webpack_public_path__ + "static/media/Civilization.739a7fb4.jpg";